var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#C63127"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6L12.2048 21.592L20.8496 11.0726L17.789 8.16677L6 6ZM8.19967 7.24026L16.6972 8.80234L13.3988 11.5471L8.19967 7.24026ZM7.6104 7.82038L13.0288 12.309L12.1816 19.3084L7.6104 7.82038ZM17.5992 9.12136L19.4026 10.8336L14.4705 11.7258L17.5992 9.12136ZM13.8131 12.6803L19.2747 11.6928L13.0101 19.3158L13.8131 12.6803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/Tron.cee649755d7921af9a798687a06901b5.svg";
export { ForwardRef as ReactComponent };